import { Component, inject, OnDestroy, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ValidationErrorsComponent } from '../../../../../../common/validation-errors/validation-errors.component';
import { ParcelsCrudComponent } from '../../../common/components/parcels/parcels-crud/parcels-crud.component';
import { NgxMaskDirective } from 'ngx-mask';
import {
  DecisionOnDeterminingTheLocationOfAPublicPurposeInvestmentCharacteristicsForm
} from './forms/decision-on-determining-the-location-of-a-public-purpose-investment-characteristics.form';
import {
  selectApplication,
  selectLoading,
  selectPending
} from '../../../../../../store/selectors/application.selectors';
import { ApplicationAppEntityApplicationRead } from '../../../../../../openapi';
import { Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { updateApplication } from '../../../../../../store/actions/application.actions';
import { stages } from '../../decision-on-determining-the-location-of-a-public-purpose-investment.routes';

@Component({
  selector: 'app-decision-on-determining-the-location-of-a-public-purpose-investment-characteristics-section',
  standalone: true,
  imports: [
    StagesComponent,
    SpinnerComponent,
    ReactiveFormsModule,
    CommonModule,
    ValidationErrorsComponent,
    ParcelsCrudComponent,
    NgxMaskDirective
  ],
  providers: [DecisionOnDeterminingTheLocationOfAPublicPurposeInvestmentCharacteristicsForm],
  templateUrl: './decision-on-determining-the-location-of-a-public-purpose-investment-characteristics-section.component.html'
})
export class DecisionOnDeterminingTheLocationOfAPublicPurposeInvestmentCharacteristicsSectionComponent implements OnDestroy {

  private store$: Store = inject(Store);

  private route: ActivatedRoute = inject(ActivatedRoute);

  private router: Router = inject(Router);

  public stages: string[] = stages;

  public form: DecisionOnDeterminingTheLocationOfAPublicPurposeInvestmentCharacteristicsForm = inject(DecisionOnDeterminingTheLocationOfAPublicPurposeInvestmentCharacteristicsForm);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  private fetchApplication: Subscription = toObservable(this.application).subscribe(app => {
    if (app) {
      this.form.patchFormValues(app);
    }
  });

  public submitAndGoNext(): void {
    if (this.form.valid) {
      this.store$.dispatch(updateApplication({
        id: this.application()?.uuid || '',
        application: this.form.toWriteModel(),
        successFnc: (applicationId: string) => {
          this.router.navigate(
            ['../obsluga-komunikacyjna'],
            {
              relativeTo: this.route
            }
          );
        },
        failureFnc: () => {
        }
      }));
    } else {
      this.form.markAllAsTouched();
    }
  }

  public onCancel(): void {
    this.router.navigate(['../teren-objety-wnioskiem'], { relativeTo: this.route });
  }

  public ngOnDestroy(): void {
    this.fetchApplication.unsubscribe();
  }
}
